import { jsx as ___EmotionJSX } from "@emotion/core";

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import ButtonContent from "./ButtonContent/ButtonContent";
import style from "./Button.style";
import ButtonBase from "../ButtonBase/ButtonBase";

const Button = (_ref) => {
  let {
    children,
    type,
    size,
    iconLeft,
    iconRight,
    loading,
    disabled,
    className,
    onClick,
    id
  } = _ref,
      props = _objectWithoutProperties(_ref, ["children", "type", "size", "iconLeft", "iconRight", "loading", "disabled", "className", "onClick", "id"]);

  return ___EmotionJSX(ButtonBase, {
    css: style.container.bySize[size],
    disabled: disabled,
    className: className,
    onClick: onClick,
    type: type,
    id: id,
    "data-testid": props['data-testid'],
    "aria-label": props['aria-label']
  }, ___EmotionJSX(ButtonContent, {
    loading: loading,
    IconLeft: iconLeft,
    IconRight: iconRight,
    size: size
  }, children));
};

Button.defaultProps = {
  type: 'secondary',
  size: 'medium',
  loading: false,
  disabled: false,
  iconLeft: undefined,
  iconRight: undefined,
  className: undefined,
  onClick: undefined,
  id: null,
  'data-testid': '',
  'aria-label': ''
};
Button.propTypes = {
  /**
  * Main styling
  */
  type: PropTypes.oneOf(['primary', 'secondary', 'tertiary', 'special']),
  size: PropTypes.oneOf(['small', 'medium']),
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  iconLeft: PropTypes.elementType,
  iconRight: PropTypes.elementType,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func,
  id: PropTypes.string,
  'data-testid': PropTypes.string,
  'aria-label': PropTypes.string
};
export default React.memo(Button);